import request from '@/utils/request'

// 查询盒子列表
export function boxList (data) {
  return request({
    url: '/thr/box/getBoxList',
    method: 'post',
    data
  })
}

// 查询盒子消息提醒
export function boxCount (data) {
  return request({
    url: '/thr/box/getBoxCount',
    method: 'post',
    data
  })
}

// 增加接收人
export function addBoxEmpl (data) {
  return request({
    url: '/thr/box/addBoxEmpl',
    method: 'post',
    data
  })
}

// 确认完成
export function addFinish (data) {
  return request({
    url: '/thr/box/addFinish',
    method: 'post',
    data
  })
}

// 查看招标项目信息
export function projectInfo (throwProjectId) {
  return request({
    url: `/thr/project?throwProjectId=${throwProjectId}`,
    method: 'get'
  })
}

// 获取招标类型
export function throwType () {
  return request({
    url: '/thr/project/get/throw/type',
    method: 'get'
  })
}

// 人员检索回填
export function retrievalBack (data) {
  return request({
    url: '/sso/employee/retrieval/back',
    method: 'post',
    data
  })
}

// 合同检索回填
export function contractBack (data) {
  return request({
    url: '/contract/contract/system/thr/contract/scanFile/list',
    method: 'post',
    data
  })
}

// 造价检索回填
export function manufacturingcostBack (data) {
  return request({
    url: '/manufacturingcost/report/scanFile/thr/upload',
    method: 'post',
    data
  })
}

// 审计检索回填
export function auditBack (data) {
  return request({
    url: '/audit/audit/report/scanFile/thr/upload',
    method: 'post',
    data
  })
}

// 监理检索回填
export function supervisorBack (data) {
  return request({
    url: '/supervisor/projectDebriefingFile/insertSupervisorReportStampedScannedFile',
    method: 'post',
    data
  })
}
